import { FilterWorkflowComponent } from './common/filtercomponent';
import { ColumnDataType, Provider, WorkflowCodeType, WorkflowComponentParamType } from '../types';
import dedent from 'ts-dedent';
import { formatValue, getValueTypeFromSchema } from '../utils';
const operators = new Map([
    ['equal to', '='],
    ['not equal', '!='],
    ['less than', '<'],
    ['greater than', '>'],
    ['equal or less than', '<='],
    ['equal or greater than', '>=']
]);
class WhereSimplified extends FilterWorkflowComponent {
    constructor() {
        super({
            name: 'native.wheresimplified',
            group: 'Data Preparation',
            title: 'Simple Filter',
            description: `
      This component filters an input table according to a filter expression based on a single column.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'column',
                type: WorkflowComponentParamType.Column,
                title: 'Column',
                parent: 'source',
                dataType: [
                    ColumnDataType.String,
                    ColumnDataType.Number,
                    ColumnDataType.Date,
                    ColumnDataType.Datetime,
                    ColumnDataType.Time,
                    ColumnDataType.Timestamp,
                    ColumnDataType.Boolean
                ]
            },
            {
                name: 'operator',
                type: WorkflowComponentParamType.Selection,
                title: 'Operator',
                options: Array.from(operators.keys())
            },
            {
                name: 'value',
                type: WorkflowComponentParamType.String,
                title: 'Value'
            }
        ]);
    }
    async _getMatchCode(params, envVars, workflow, componentName, connection, codeType, schema) {
        if (codeType === WorkflowCodeType.DryRun) {
            return dedent `SELECT *
        FROM ${connection.quoteName(params.source)}`;
        }
        let value = params.value;
        if (!workflow.isExpression(componentName, 'value')) {
            const valueType = getValueTypeFromSchema(params.column, schema);
            value = formatValue(params.value, connection.type, valueType);
        }
        return dedent `SELECT *
      FROM ${connection.quoteName(params.source)}
      WHERE
        ${params.column} ${operators.get(params.operator)} ${value}`;
    }
    async _getUnmatchCode(params, matchTablename, envVars, workflow, componentName, connection, codeType, schema) {
        if (codeType === WorkflowCodeType.DryRun) {
            if (connection.type === Provider.DatabricksRest) {
                return dedent `SELECT /*+ REPARTITION(40) */
            *
          FROM ${connection.quoteName(params.source)}`;
            }
            else {
                return dedent `SELECT *
          FROM ${connection.quoteName(params.source)}`;
            }
        }
        let value = params.value;
        if (!workflow.isExpression(componentName, 'value')) {
            const valueType = getValueTypeFromSchema(params.column, schema);
            value = formatValue(params.value, connection.type, valueType);
        }
        if (connection.type === Provider.DatabricksRest) {
            return dedent `SELECT /*+ REPARTITION(40) */
          *
        FROM ${connection.quoteName(params.source)}
        WHERE NOT
          ${params.column} ${operators.get(params.operator)} ${value}`;
        }
        else {
            return dedent `SELECT *
        FROM ${connection.quoteName(params.source)}
        WHERE NOT
          ${params.column} ${operators.get(params.operator)} ${value}`;
        }
    }
}
export { WhereSimplified };
